import routerFactory from "@cirrus/routing/components/index.jsx"
import { types } from "@cirrus/routing/services/actions"
import routerActions from "./alt/actions"
import routerSelectors from "./redux/selectors"

export const DeliveryRouter = routerFactory({
  getLocation: routerSelectors.getLocation,
  onLocationChanged: (dispatch) => (location, action) => {
    dispatch({
      type: types.LOCATION_CHANGED,
      payload: {
        location,
        action,
      },
    })
    routerActions.locationChanged(location)
  },
})
